export const environment = {
  production: true,
  cognitoUserPoolId: 'us-west-2_B2y9iRixd',
  cognitoAppClientId: '1lpf8fbhoj42du96l3tkv71h5s',
  awsRegion: 'us-west-2'
};
